// extracted by mini-css-extract-plugin
module.exports = {"korosWrapper":"korosWrapper_korosWrapper__QVe9g","koros":"korosWrapper_koros__XvgOi"};